import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { formatAmount } from "../constants"

// Horizontal stacked bullet bar for Budget vs Actual: committed / unpaid /
// paid segments rendered over the total budget track, with the remainder shown
// as empty track. Built purely from existing color tokens.
const SEGMENTS = [
  { key: "committed", color: "info", label: "Committed" },
  { key: "approvedUnpaid", color: "warning", label: "Unpaid" },
  { key: "approvedPaid", color: "success", label: "Paid" },
]

const BulletBar = ({ row = {} }) => {
  const total = Number(row.totalBudget) || 0
  const pct = (v) => (total > 0 ? Math.min(100, (Number(v) || 0) / total * 100) : 0)

  return (
    <MDBox>
      <MDBox
        display="flex"
        width="100%"
        height="0.5rem"
        borderRadius="md"
        bgColor="grey-100"
        overflow="hidden"
      >
        {SEGMENTS.map((seg) => {
          const w = pct(row[seg.key])
          if (w <= 0) return null
          return (
            <MDBox key={seg.key} width={`${w}%`} bgColor={seg.color} height="100%" />
          )
        })}
      </MDBox>
      <MDBox display="flex" flexWrap="wrap" gap={2} mt={0.75}>
        {SEGMENTS.map((seg) => (
          <MDBox key={seg.key} display="flex" alignItems="center" gap={0.5}>
            <MDBox width="0.5rem" height="0.5rem" borderRadius="50%" bgColor={seg.color} />
            <MDTypography variant="caption" color="text">
              {seg.label}: {formatAmount(row[seg.key])}
            </MDTypography>
          </MDBox>
        ))}
        <MDBox display="flex" alignItems="center" gap={0.5}>
          <MDBox width="0.5rem" height="0.5rem" borderRadius="50%" bgColor="grey-400" />
          <MDTypography variant="caption" color="text">
            Remaining: {formatAmount(row.remaining)}
          </MDTypography>
        </MDBox>
      </MDBox>
    </MDBox>
  )
}

export default BulletBar
